import { render, staticRenderFns } from "./customDevelopment.vue?vue&type=template&id=19e7b900&scoped=true&"
import script from "./customDevelopment.vue?vue&type=script&lang=js&"
export * from "./customDevelopment.vue?vue&type=script&lang=js&"
import style0 from "./customDevelopment.vue?vue&type=style&index=0&id=19e7b900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e7b900",
  null
  
)

export default component.exports